import { mapActions, mapState } from 'vuex';
import loaderMixin from '@/mixins/loader';
import Contract from '@/models/contract';
import marketContractInfoV2, { MARKET_CONTRACT_INFO_VALUES_LAYOUT } from '@/components/market/v2/market-contract-info-v2/market-contract-info-v2.vue';
import contentLoaderMixin from '@/mixins/contentLoader';
import { isMarketSingle } from '@/utils/helpers';

export default {
  mixins: [
    contentLoaderMixin,
    loaderMixin,
  ],
  props: {
    contractId: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      default: null,
    },
  },
  components: {
    marketContractInfoV2,
  },
  data() {
    return {
      MARKET_CONTRACT_INFO_VALUES_LAYOUT
    }
  },
  computed: {
    ...mapState('market', ['relatedContracts']),
    items() {
      const contracts = this.relatedContracts.map((i) => {
        const instance = new Contract(i);
        return {
          id: i.contractId,
          marketName: i.marketShortName || i.marketName,
          marketId: i.marketId,
          marketType: i.marketType,
          contractName: isMarketSingle(i) ? 'YES' : (i.contractShortName || i.contractName),
          image: i.contractImageSmallUrl || i.contractImageUrl,
          price: instance.changePriceAsCents,
          priceAsCents: instance.lastTradePriceAsCents,
          lastClosePrice: instance.lastClosePrice,
          contracts: [
            i
          ]
        }
      })
      return (this.max !== null) ? (contracts || []).slice(0, this.max) : (contracts || []);
    },
  },
  methods: {
    ...mapActions('market', ['getRelatedContracts', 'clearRelatedContracts']),
    itemLink(item) {
      return {
        name: 'market-details',
        params: { marketId: item.marketId },
        query: { contractId: item.id }
      }
    },
    loadContracts() {
      this.getRelatedContracts(this.contractId)
        .then(() => {
          this.isComponentReady = true;
        })
        .catch(() => {
          this.isComponentReady = true;
        });
    },
    titleLink(item) {
      return {
        name: 'market-details',
        params: { marketId: item.marketId },
      }
    },
  },
  watch: {
    contractId: {
      handler () {
        this.loadContracts();
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    this.clearRelatedContracts();
  },
};



// WEBPACK FOOTER //
// ./src/components/related-contracts-sushi/related-contracts-sushi.js